module.exports = __webpack_public_path__ + "b2028ce9da7a006891571201b955058a.svg";